// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"28d809de","53":"6937cac2","267":"611214fd","378":"ac0de690","397":"e4758fa4","407":"2aebdfa6","453":"7bf88bcb","552":"bd08047a","586":"c1a51b56","599":"fea828b2","649":"d926e197","982":"6dd3ea44"}[chunkId] + ".chunk.js";
};